<div class="background-settings-toggle" *ngIf="showTextSettings">
  <div
    class="container"
    capraTooltip
    tooltipPlacement="bottom"
    tooltipSize="regular"
    tooltipContent="To apply color to text or background, make sure only discrete fields are on X or Y"
    [tooltipIsDisabled]="enableTextSettings"
    [tooltipInteractive]="false"
    [tooltipDelay]="[500, 0]">
    <capra-icon-button
      icon="icon-chart-table"
      size="medium"
      class="set-as-cta"
      data-test="set-as-background-cta"
      capraTooltip
      tooltipPlacement="bottom"
      tooltipContent="Apply to background"
      [tooltipInteractive]="false"
      [tooltipDelay]="[500, 0]"
      [tooltipIsDisabled]="!enableTextSettings"
      [class.selected]="isUseAsBackground"
      [disabled]="!enableTextSettings"
      (clicked)="onMarkTargetClick('background')"
    ></capra-icon-button>

    <capra-icon-button
      icon="icon-control-insert-text"
      size="medium"
      class="set-as-cta"
      data-test="set-as-foregrouond-cta"
      capraTooltip
      tooltipPlacement="bottom"
      tooltipContent="Apply to text"
      [tooltipIsDisabled]="!enableTextSettings"
      [tooltipInteractive]="false"
      [tooltipDelay]="[500, 0]"
      [class.selected]="!isUseAsBackground"
      [disabled]="!enableTextSettings"
      (clicked)="onMarkTargetClick('foreground')"
    ></capra-icon-button>
  </div>
</div>